import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";
import AssembleiaAtaDTO from "app/models/assembleia/assembleiaAtaDTO.model";
import { Assembleia } from "app/pages/full-pages/assembleia/model/Assembleia";
import { Observable } from "rxjs";

export abstract class AbAssembleia extends AppService {

  abstract salvarAlterarDados(entity: Assembleia);
  abstract adicionarAta(assembleiaAtaDTO: AssembleiaAtaDTO, assembleiaId: number);
  abstract getAssembleias(filter: AppFilter);
  abstract deleteAssembleiaById(id: number);
  abstract getAssembleiaById(id: number);
  abstract enviarEmailNovaAssembleia(id: number);
  abstract enviarEmailCancelamentoAssembleia(id: number);
  abstract downloadArquivo(assembleiaId: number, nomeArquivo: string);
  abstract deleteArquivo(assembleiaId: number, nomeArquivo: string);
  abstract gerarEdital(id: number): Observable<any>;
  abstract isIntegrador(): boolean;
  abstract setAssembleiaSubject(data: Assembleia): void;
  abstract getAssembleiaSubject(): Observable<unknown>;
}
